import SignatureCanvasLib from 'react-signature-canvas'

import PreviewImage from './PreviewImage'
import useTranslations from '../../../hooks/useTranslations'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDModal from '../../../shared/antd/ANTDModal'
import { EyeOutlined } from '../../../utils/icons'
import signatureCanvas from '../container/signatureCanvas.container'
import '../SignatureCanvas.scss'

const SignatureCanvas = ({
  value,
  onChange,
  disabled,
  width = 500,
  height = 300,
  canvasProps = {},
  nestedKey,
  apiCall,
  filePath,
  ...props
}) => {
  const { t } = useTranslations()
  const {
    signatureRef,
    isModalOpen,
    tempSignature,
    handleOpenModal,
    handleCloseModal,
    handleClear,
    handleSave,
    handleEnd,
    imagePreview,
    handlePreview,
    handleCancelPreview,
    handleRemove,
  } = signatureCanvas({
    value,
    onChange,
    disabled,
    filePath,
    apiCall,
    nestedKey,
  })

  return (
    <div className="signature-canvas-wrapper" {...props}>
      <div
        className="signature-canvas-upload-card mt-5"
        onClick={value?.fileList?.[0]?.url ? handlePreview : handleOpenModal}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {value?.fileList?.[0]?.url ? (
          <div className="signature-preview">
            <img
              src={value?.fileList?.[0]?.url || ''}
              alt="Signature"
              className="signature-preview-img"
            />
            <div className="signature-preview-overlay">
              <EyeOutlined className="signature-edit-icon" />
            </div>
            {!disabled && (
              <span
                className="signature-remove-icon"
                onClick={e => {
                  e.stopPropagation()
                  handleRemove()
                }}
              />
            )}
          </div>
        ) : (
          <div className="signature-upload-placeholder">
            <div className="signature-upload-text">{t('txt_Upload')}</div>
          </div>
        )}
      </div>

      <ANTDModal
        title={t('job_TakeSignature')}
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={[
          <ANTDButton
            key="cancel"
            onClick={handleCloseModal}
            style={{ backgroundColor: '#ffa69e', borderColor: '#ffa69e' }}
          >
            {t('msg_Cancel')}
          </ANTDButton>,
          <ANTDButton
            key="clear"
            type="default"
            onClick={handleClear}
            style={{ backgroundColor: '#93e1d8', borderColor: '#93e1d8' }}
          >
            {t('btn_Clear')}
          </ANTDButton>,
          <ANTDButton
            key="save"
            type="primary"
            onClick={handleSave}
            disabled={!tempSignature}
          >
            {t('btn_Save')}
          </ANTDButton>,
        ]}
        className="signature-modal"
      >
        <div className="signature-canvas-container">
          <SignatureCanvasLib
            ref={signatureRef}
            canvasProps={{
              width: width,
              height: height,
              className: 'signature-canvas',
              ...canvasProps,
            }}
            onEnd={handleEnd}
            backgroundColor="#ffffff"
            penColor="#000000"
          />
        </div>
      </ANTDModal>
      <PreviewImage {...{ imagePreview, handleCancel: handleCancelPreview }} />
    </div>
  )
}

export default SignatureCanvas
